<template src='./list.pug' lang='pug'></template>

<script>
import { Event } from 'vue-tables-2'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { filterBySituation, filterByAccessProfileName, filterByEmail } from '../../../../utils/customFilters.js'
import customSorter from '../../../../utils/customSorter.js'
import { generateLoadingRows } from '../../../../utils/grid-load-transition.js'
import PATHS from '../../../../router/routesMap.js'

const templatesWhenIsLoaded = {
  nomePerfilAcesso: (h, row) => {
    return row.perfilAcesso ? row.perfilAcesso.nomePerfilAcesso : '-'
  },
  situacao: (h, row) => {
    return row.ativo ? 'Ativo' : 'Inativo'
  }
}

export default {
  name: 'OperatorList',

  components: {
    PageTitle,
    LoadingPlaceholder,
    ButtonPrimary
  },

  data () {
    return {
      isLoadingData: true,
      loggedUserProfileId: this.$store.getters.accessProfileId,
      operators: generateLoadingRows(10),
      columns: ['nome', 'email', 'nomePerfilAcesso', 'situacao', 'acoes'],
      options: {
        columnsClasses: { nome: 'col-md-4', email: 'col-md-3', situacao: 'col-md-2', acoes: 'col-md-1', nomePerfilAcesso: 'col-md-2' },
        headings: {
          nome: this.$t('administracao.operadores.labels.nome'),
          nomePerfilAcesso: this.$t('administracao.perfilAcesso.labels.perfil'),
          email: this.$t('administracao.operadores.labels.email'),
          acoes: this.$t('administracao.perfilAcesso.labels.acoes'),
          situacao: this.$t('administracao.operadores.labels.situacao')
        },
        filterable: ['nome'],
        customFilters: [{
          name: 'situacao',
          callback: filterBySituation
        }, {
          name: 'nomePerfilAcesso',
          callback: filterByAccessProfileName
        }, {
          name: 'email',
          callback: filterByEmail
        }],
        filterByColumn: true,
        perPageValues: [],
        templates: {
          nome: LoadingPlaceholder,
          email: LoadingPlaceholder,
          situacao: LoadingPlaceholder,
          acoes: LoadingPlaceholder,
          nomePerfilAcesso: LoadingPlaceholder
        },
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['nome', 'email', 'nomePerfilAcesso', 'situacao'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        orderBy: {
          ascending: true,
          column: 'nome'
        },
        customSorting: {
          nome: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'nome')
            }
          },
          nomePerfilAcesso: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'nomePerfilAcesso')
            }
          },
          situacao: function (ascending) {
            return function (a, b) {
              return customSorter.booleanSorter(ascending, a, b, 'ativo')
            }
          }
        }
      }
    }
  },

  methods: {
    handleFilter (event, column) {
      Event.$emit(`vue-tables.filter::${column}`, event.currentTarget.value)
    },

    /**
     * Usuario Master edita/cadastra tudo.
     * Usuario nao Master edita/cadastra perfis nao master.
     */
    canEditOperator (profile = {id: null}) {
      return (this.loggedUserProfileId && this.loggedUserProfileId.toString() === '2') || (profile.id && profile.id.toString() !== '2')
    },

    edit (userId) {
      trackAnalyticsEvent(this, 'edit-click', 'edit-operador', 'edit-operador')

      this.$store.dispatch('setOperatorToEdit', userId).then((response) => {
        this.$router.push(PATHS.NEW_OPERATOR)
      })
    },

    newProfile () {
      this.$router.push(PATHS.NEW_OPERATOR)
    },

    loadOperators () {
      let url = 'operator'
      this.$store.dispatch('getOperators', url).then((response) => {
        this.operators = response.data.map(operator => {
          operator.perfilAcesso = {...operator.perfilAcesso, nomePerfilAcesso: operator.perfilAcesso.nome}
          return operator
        }).flat()
        this.isLoadingData = false
        this.options.templates = templatesWhenIsLoaded
      })
    }
  },

  created () {
    this.loadOperators()
  }
}
</script>

<style scoped>
.actions {
  text-align: center;
}

.action {
  text-align: center;
  background-color: transparent !important;
  border: none !important;
  margin: 0 5px 0 5px;
  color: #1c3b60
}

.action:hover {
  border: none !important;
}

.action:disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// List.vue?a6d7701c